var path = 'app/scripts/modules/azure/securityGroup/clone/cloneSecurityGroup.html';
var html = "\n<v2-modal-wizard heading=\"Clone Security Group\">\n  <v2-wizard-page key=\"Location\" label=\"Location\">\n    <ng-include src=\"pages.location\"></ng-include>\n  </v2-wizard-page>\n  <v2-wizard-page key=\"Ingress\" label=\"Ingress\" done=\"true\">\n    <ng-include src=\"pages.ingress\"></ng-include>\n  </v2-wizard-page>\n</v2-modal-wizard>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/azure/securityGroup/clone/cloneSecurityGroup.html
// module id = 1678
// module chunks = 0